import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { format } from "date-fns";
import { Calendar } from "lucide-react";
import { ScrollArea } from "../../components/ui/scroll-area";
interface SelectedRental {
  periodNo: number;
  fromDate: string;
  toDate: string;
  dueDate: string;
  baseRentRounded: number;
  gstRaw: number;
  total: number;
}

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedRentals: SelectedRental[];
  pvTotal: number;
}

export default function SelectedRentalsModal({ open, onOpenChange, selectedRentals, pvTotal }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="h-[85vh] md:max-w-6xl max-h-[85vh] ms-auto w-[90%] rounded-t-xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5" />
            Selected Rental Periods ({selectedRentals.length})
          </DialogTitle>
        </DialogHeader>
        
        {/* <div className="border rounded-lg overflow-hidden"> */}
           <ScrollArea className="h-fit border rounded-lg p-5 b-5">
           <Table>
            <TableHeader>
              <TableRow className="bg-muted/50">
                <TableHead>Period</TableHead>
                <TableHead>From Date</TableHead>
                <TableHead>To Date</TableHead>
                <TableHead>Due Date</TableHead>
                <TableHead className="text-right">Base Rent</TableHead>
                <TableHead className="text-right">GST</TableHead>
                <TableHead className="text-right">Total</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {selectedRentals.length > 0 ? (
                <>
                  {selectedRentals.map((rental, idx) => (
                    <TableRow key={idx}>
                      <TableCell className="font-medium">{rental.periodNo}</TableCell>
                      <TableCell>{format(new Date(rental.fromDate), "MMM dd, yyyy")}</TableCell>
                      <TableCell>{format(new Date(rental.toDate), "MMM dd, yyyy")}</TableCell>
                      <TableCell>{format(new Date(rental.dueDate), "MMM dd, yyyy")}</TableCell>
                      <TableCell className="text-right">₹{rental.baseRentRounded?.toLocaleString("en-IN")}</TableCell>
                      <TableCell className="text-right">₹{rental.gstRaw?.toLocaleString("en-IN")}</TableCell>
                      <TableCell className="text-right">₹{(rental.baseRentRounded + (rental.gstRaw ?? 0)).toLocaleString("en-IN")}</TableCell>
                    </TableRow>
                  ))}
                  <TableRow className="bg-muted/50 font-medium">
                    <TableCell colSpan={6}>Total Present Value</TableCell>
                    <TableCell className="text-right font-bold">₹{pvTotal.toLocaleString("en-IN")}</TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={7} className="text-center py-8 text-muted-foreground">
                    No rental periods selected
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
           </ScrollArea>
          
        {/* </div> */}
      </DialogContent>
    </Dialog>
  );
}
